module.exports = __webpack_public_path__ + "static/img/information.41165c4a.png";